export const environment = {
    production: false,
    apiUrl: 'https://api.euromoselle.preprod-s4.cawita.com',
    assetUrl: 'https://assets.euromoselle.preprod-s4.cawita.com',
    customerSpaceUrl: 'https://share.euromoselle.preprod-s4.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LccjzQqAAAAAB1Qnsa7DHRvUR1VMDKSFnIejSrw'
};